import { LitElement } from 'lit';
import { html, css } from 'lit';
import '../../Time/Timestamp';
import { Text } from '../../Text/Text.js';
import { processTextWithMentions } from '../../../../lib/taguser.js';
import '../../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';
import '../../EmojiReactions/EmojiReactions.js';
import '../../../../components/ChatUIComponent/ReactionContainer.js'
import'../../ForwardMessage/ForwardUi.js'

class IncomingTextMessageBubble extends LitElement {
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    height: { type: String },
    width: { type: String },
    time: { type: String },
    textContent: { type: String },
    alignSelf: { type: String },
    fontFamily: { type: String },
    color: { type: String },
    customType: { type: String }, // add customType
    mentionedUsers: { type: Array },

    reactions: { type: Object },
    messageId: { type: String },
    showReactionButton: { type: Boolean },
    showEmojiReactions: { type: Boolean },
    showConfirmationPopup: { type: Boolean },
    selectedEmojiToRemove: { type: Object },
    showAllReactionsPopup : {type: Boolean},
    userMetaData: {type: Object},
    messageType: { type: Number },
    timeColor: { type: String },

    showReactionOnHover: {type: Boolean}
  };

  constructor() {
    super();
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
    this.showAllReactionsPopup = false;
    this.showReactionOnHover = true;
  }

  static styles = css`
    .message-container {
      position: relative;
      min-width: fit-content;
      width: fit-content;
      max-width: 80%;
      align-self: center;
      overflow-wrap: break-word;
      margin-left: 10px;
    }
    .image-container {
      cursor: pointer;
    }
    .full-screen-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100dvh;
      background-color: rgba(0, 0, 0, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }
    .full-screen-image {
      max-width: 90%;
      max-height: 90%;
      object-fit: cover;
    }
    .close-button {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 2rem;
      color: white;
      cursor: pointer;
      background: transparent;
      border: none;
    }
    emoji-reactions {
      position: absolute;
      top: 15px;
      left: 0;
    }

    .reactions-display {
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: 0;
      margin-top: 4px;
      background-color: transparent;
      position: absolute;
      right: 10px;
      bottom: -10px;
    }

    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      font-size: 20px;
      background: var(--bg-secondary-color);
      cursor: pointer;
    }

    .reaction-button {
      position: absolute;
      right: -22px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }



    .reaction-list-item {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      padding: 4px;
    }

    .reaction-list-item:hover {
      background: var(--bg-secondary-color);
      border-radius: 4px;
    }

     .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }

    reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }
  `;

  openFullScreen() {
    this.isFullScreen = true;
  }

  closeFullScreen() {
    this.isFullScreen = false;
  }

  static getCustomTypeStylesAndSuffix(customType, bgColor, textColor) {
    if (customType === 'PAYMENT_ESCROWED') {
      return {
        suffix: 'Payment Escrowed',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      };
    } else if (customType === 'DEAL_COMPLETE') {
      return {
        suffix: 'Deal Completed',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      };
    } else if (customType === 'CANCEL_DEAL' ||  customType === 'CANCEL_OFFER') {
      return {
        suffix: 'Deal Cancelled',
        showSuffix: true,
        bgColor: '#FF00001A',
        textColor: '#FF0000',
      };
    } else if (customType === 'OFFER_SENT') {
      return {
        suffix: 'Offer Sent',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    }
    else if (customType === 'COUNTER_OFFER') {
      return {
        suffix: ' Counter Offer',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'EDIT_OFFER') {
      return {
        suffix: ' Edit Offer',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    }
    else if (customType === 'REVIEW_RATING') {
      return {
        suffix: '',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'ACCEPT_OFFER') {
      return {
        suffix: ' Accept Offer',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'EXCHANGE_OFFER_SENT') {
      return {
        suffix: ' Trade Offer Sent',
        showSuffix: true,
        bgColor: '#2411721A',
        textColor: '#241172',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'ACCEPT_EXCHANGE_OFFER') {
      return {
        suffix: ' Offer Accepted',
        showSuffix: true,
        bgColor: '#1CA48F1A',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    }
    return {
      suffix: '',
      showSuffix: false,
      bgColor: bgColor,
      textColor: textColor,
      fontSize: 'inherit',
      fontWeight: 'inherit',
    };
  }
  handleMentionClick = user => {
    this.dispatchEvent(
      new CustomEvent('tagUserClick', {
        detail: { userId: user?.userId, userName: user?.userName },
        bubbles: true,
        composed: true,
      }),
    );
  };

  handleMouseEnter() {
    if(this.showReactionOnHover) {
    this.showReactionButton = true;
    }
  }

  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;
      
      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

  handleOutsideClick = (e) => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');
    
    const path = e.composedPath();
    
    if (this.showEmojiReactions &&
        !path.includes(emojiReactions) &&
        !path.includes(messageContainer)) {
      this.showEmojiReactions = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
    
    if (this.showConfirmationPopup &&
        !path.includes(reactionContainer) &&
        !path.includes(messageContainer)) {
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
 
  toggleEmojiReactions() {
    this.showConfirmationPopup = false;
    this.showEmojiReactions = !this.showEmojiReactions;
    
    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }
  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }
  

  handleReactionRemove(reaction) {
    this.showEmojiReactions = false;

    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;

    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }

  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }


  render() {
    const {
      suffix,
      showSuffix,
      bgColor: customBgColor,
      textColor: customTextColor,
      fontSize: customFontSize,
      fontWeight: customFontWeight,
    } = IncomingTextMessageBubble.getCustomTypeStylesAndSuffix(
      this.customType,
      this.bgColor || '#EFF1FA',
      this.color
    );

    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0); 
    
    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;
    

    return html`
      <div
        class="message-container"
        @emoji-selected="${this.handleEmojiSelect}"
        @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}"
        style="padding:${this.padding || '10px'}; 
          border-width: ${this.borderWidth};
          border-color: ${this.borderColor};
          border-style:${this.borderStyle};
          border-radius:${this.borderRadius || '7px'};
          height:${this.height};
          background-color:${this.bgColor || '#EFF1FA'};
          align-self: ${this.alignSelf || 'left'};
          font-family: ${this.fontFamily};
          color: ${this.color};
         "
      >
        ${showSuffix
          ? html`<div class="message-suffix-container" style="background-color:${customBgColor}; color:${customTextColor}; font-size:${customFontSize}; font-weight:${customFontWeight}; margin-bottom:4px; padding:2px 8px; border-radius:6px; display:inline-block; width:max-content;">${suffix}</div>`
          : null}
        ${this.messageType === 1
          ? html`
              <forward-ui></forward-ui>
            `
          : null}
        ${this.showReactionButton
          ? html`
              <div class="reaction-button" @click="${() => this.toggleEmojiReactions()}">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
                  <path
                    d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"
                  />
                </svg>
              </div>
            `
          : ''}
        ${Text({
          content: processTextWithMentions(this.textContent, this.mentionedUsers, this.handleMentionClick, false) || 'some incoming message some somesomesomesome',
          textAlign: 'left',
          fontFamily: this.fontFamily,
          color: this.color,
        })}

        <timestamp-element .time="${this.time || new Date().toISOString()}" .color="${this.timeColor}"></timestamp-element>
        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
         ${remainingCount > 0
            ? html`
                <span @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count" > +${remainingCount} </span>
      
              `
            : ''}
        </div>

        ${this.showConfirmationPopup
          ? html`
             <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container>
            `
          : ''}

        <div class="emoji-slider">
          ${this.showEmojiReactions
            ? html`
                <emoji-reactions
                  .isOpen="${this.showEmojiReactions}"
                  .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}"
                  .selectedEmojis="${this.reactions}"
                ></emoji-reactions>
              `
            : ''}
        </div>
      </div>
    `;
  }
}

customElements.define('incoming-text-message-bubble', IncomingTextMessageBubble);
